import { createSelector } from 'reselect'
import { getEntity } from '../../common/entities/selectors/base'

export const creditTransactionForPayOutSelector = createSelector(
  [getEntity('CreditTransaction'), (_, payOutId) => payOutId],
  (creditTransactions, payOutId) =>
    creditTransactions.find((creditTransaction) => creditTransaction.get('payout') === payOutId)
)
